export default __webpack_public_path__ + "static/media/reportnet-3.0-logo.6a796015.png";